import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { Globals } from '../_helpers';
import { AlertService, AuthenticationService } from '../_services';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})


export class DashboardComponent implements OnInit {
  public alertOption: SweetAlertOptions = {};  
  @ViewChild('msgSwal') private msgSwal: SwalComponent;

  title = 'Pareekshn';
  selectedValue: any = 'topic';
  userinfo: any;
  studentid: number = 0;
  isErrorUsername: boolean;
  errorMsg: any;
  loading: boolean;
  examdata: any;
  futureexams: any;
  pastexams: any;
  livexam: any;
  isValid = true;
  pg: number = 0;
  usertoken: string;
  todayDate: Date = new Date();
  liveexam: number = 0;
  pastexam: number = 0;
  futureexam: number = 0;
  examicon: string;
  sectorlist = [];
  /* Chart Variable */
  public pieChartLabels: string[] = ['Pass', 'Fail', 'Result Awaited'];
  public pieChartData: number[] = [];
  public pieChartType: string = 'pie';
  public pieChartLegend = false;
  public chartColors: any[] = [{
      backgroundColor: ["#44e51e", "#ff7272", "#707070"]
  }];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private globals: Globals,
    private spinner: NgxSpinnerService,
    private http: HttpClient
  ) { }

  ngOnInit() {

    //let auth_token = 'MTQ1YjE4ZDI2Mjc1MzQ4MGM2Njc5MTNlNDdmMWY2MGVfUGFyQDIzQE1F';
    this.userinfo = JSON.parse(localStorage.getItem('userinfo_ps')); //console.log(this.userinfo);
    this.studentid = this.userinfo['student_id'];
    this.usertoken = this.userinfo['usertoken'];
    this.mockExams();
    this.resultStatistics();
   

    // if (this.selectedValue = 'live-exam') {
    //   this.liveTest();
    //   this.selectedValue = 'live-exam';
    // }
    // if (this.selectedValue = 'future-exam') {
    //   this.futureTest();
    //   this.selectedValue = 'future-exam';

    // }

    // if (this.selectedValue = 'past-exam') {
    //   this.pastTest();
    //   this.selectedValue = 'past-exam';

    // }



  }
examArrLength;
examsdata = []; 
txt: string = '';
examfeeArr = {};
//taxArr = [];
exam_fee;
totalfee;
taxamount;
taxv:number = 0;
taxam;
  mockExams() {   
    this.loading = true;
    this.spinner.show();    
    this.authenticationService.mockExam(this.globals.root_url, this.studentid, this.pg, this.usertoken)
      .pipe(first())
      .subscribe(
        data => {
          this.loading = false;
          this.spinner.hide();
          if (data.code == 1000) {
            this.examsdata = [];
            this.examdata = data.exams
            this.examArrLength = this.examdata.length;
            this.examicon = "/assets/images/online-exam.png";
            for(var m =0; m < this.examArrLength; ++m)
            {
              if(this.examdata[m].exam_fee != undefined)
              {
                this.examfeeArr = this.examdata[m].exam_fee;  
                this.exam_fee = this.examfeeArr['exam_fee'];              
              }
              let taxArr = [];
              let taxv = 0;
              if(this.examdata[m].tax != undefined)
              {
                taxArr = this.examdata[m].tax;                
              } 

              for(var n =0; n < taxArr.length; ++n)
              {
                taxv = taxv + taxArr[n].tax_value;
                //this.taxam = this.taxam + this.taxArr[n].tax_value;
              }
              this.taxamount = (this.examfeeArr['exam_fee'] * taxv)/100;
              this.totalfee =  this.taxamount + this.exam_fee;

              this.examsdata.push({ duration: this.examdata[m].duration, exam_name: this.examdata[m].exam_name, id_exam: this.examdata[m].id_exam, id_sector: this.examdata[m].id_sector, id_student: this.examdata[m].id_student, isvivadone: this.examdata[m].isvivadone, login_status: this.examdata[m].login_status, login_time: 0, logout_time: 0, passcode: this.examdata[m].passcode, sector: this.examdata[m].sector, start_date: this.examdata[m].start_date, start_time: this.examdata[m].start_time, subject_code: this.examdata[m].subject_code, subject_name: this.examdata[m].subject_name, total_time_taken: this.examdata[m].total_time_taken, status: this.examdata[m].status, ptype: this.examdata[m].paid_type, payment_done: this.examdata[m].payment_done, exam_fee: this.totalfee, tax_amount: this.taxamount, fee_wtax: this.examfeeArr['exam_fee'], taxes: taxArr, refund_request: this.examdata[m].refund_request});     
              //console.log(this.examsdata);    
            }            
            this.liveexam = 1;
            this.pastexam = 0;
            if(this.examArrLength == 0)
            {
              this.txt = "You will have to select your choice of sectors to give a mock exam. After selecting a sector, we will create a mock exam for you.";
            }
          }
          else {
            this.isErrorUsername = true;
            this.errorMsg = data.status;
            this.loading = false;
            this.router.navigateByUrl('/userlogin'); 
          }
          this.spinner.hide();
        },
        error => {
          this.isErrorUsername = true;
          this.errorMsg = 'No Data Found !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
  }
 enrollExam(exam_id)
 {
 this.msgSwal.show();
  this.loading = true;
  this.spinner.show();
  const headers = { 'Authorization': 'Bearer '+ this.globals.mockAPIkey};
  //this.http.get<any>("https://admintest.pareekshn.in/ams/addcandidateinbatch?idSelfStudent="+this.studentid+"&idExam="+exam_id, { headers }).subscribe((res: any) => {
  this.http.get<any>("https://mypanel.pareekshn.com/ams/addcandidateinbatch?idSelfStudent="+this.studentid+"&idExam="+exam_id, { headers }).subscribe((res: any) => {
      var translateRes = res;
      if (res.status_code == 1000) {
        this.loading = false;
        this.spinner.hide();      
        sessionStorage.setItem('pkshn_select_exam_ps', exam_id);
        this.router.navigateByUrl('/login/'+ btoa(res.passcode));  
        //this.router.navigateByUrl('/login/'+res.passcode); 
      }
      else {
        this.loading = false;
        this.spinner.hide(); 
        this.router.navigateByUrl('/dashboard'); 
      }
        
  });
    //this.router.navigateByUrl('/dashboard');      
 }
  attemptDate;
  totalExam: number = 0;
  pastExams() {   
    this.loading = true;
    this.spinner.show();
    this.authenticationService.pastExam(this.globals.root_url, this.studentid, this.pg, this.usertoken)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            this.loading = false;
            this.spinner.hide();            
            this.examsdata = []; 
            this.examdata = data.pastExamList 
            this.examArrLength = this.examdata.length;
            for(var m =0; m < this.examArrLength; ++m)
            {
              let ldt = this.examdata[m].login_time;
              let ldt_split = ldt.split("T");
              var d = new Date(ldt_split);
              this.attemptDate = this.formatDate(d);        
              this.examsdata.push({ duration: this.examdata[m].duration, exam_name: this.examdata[m].exam_name, id_exam: this.examdata[m].id_exam, id_sector: this.examdata[m].id_sector, id_student: this.examdata[m].id_student, isvivadone: this.examdata[m].isvivadone, login_status: this.examdata[m].login_status, login_date: this.attemptDate, logout_time: this.examdata[m].logout_time, passcode: this.examdata[m].passcode, sector: this.examdata[m].sector, start_date: this.examdata[m].start_date, start_time: this.examdata[m].start_time, subject_code: this.examdata[m].subject_code, subject_name: this.examdata[m].subject_name, total_time_taken: this.examdata[m].total_time_taken, retry: this.examdata[m].retry, ptype: 0, payment_done: 0, exam_fee: 0, tax_name: '', tax_value: 0, tax_amount: 0, refund_request: 0});           
            }      
            this.examicon = "/assets/images/attempted.png";
            this.liveexam = 0;
            this.pastexam = 1;
            if(this.examArrLength == 0)
            {
              this.txt = "You will have to select your choice of sectors to give a mock exam. After selecting a sector, we will create a mock exam for you.";
            }
            else
            {
              this.totalExam = this.examArrLength;
            }            
          }
          else {
            this.isErrorUsername = true;
            this.errorMsg = data.status;
            this.loading = false;
            this.router.navigateByUrl('/userlogin');
          }
          this.spinner.hide();
        },
        error => {
          this.isErrorUsername = true;
          this.errorMsg = 'No Data Found !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
  } 
formatDate(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0'+minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
}

startExam(examid, passcode)
{
  sessionStorage.setItem('pkshn_select_exam_ps', examid);
  //console.log('/login/'+ btoa(passcode));
  this.router.navigateByUrl('/login/'+ btoa(passcode));  
}

resumeExam(examid)
{
  sessionStorage.setItem('pkshn_select_exam_ps', examid);
  this.router.navigateByUrl('/login');  
}
pdfLink: string ='';
viewResult(exam_id,student_id)
{ 
  this.loading = true;
  this.spinner.show();
    this.authenticationService.loadResult(this.globals.root_url, student_id, this.studentid, exam_id, this.usertoken)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data)
          //this.spinner.hide();
          if (data.code == 1000) {
            if(data.more_result == 1)
            {
              this.router.navigateByUrl('/results/'+ exam_id+ '/' + student_id);    
              //console.log('/results/'+ exam_id+ '/' + student_id);           
            }
            else
            {
              this.pdfLink = data.pdf_link;
              this.loading = false;
              this.spinner.hide();
              window.open(this.pdfLink, "_blank");
            }
          }
          else {
            this.generateResult(exam_id,student_id);
            this.errorMsg = data.status;
            //this.loading = false;
          }
        },
        error => {
          this.errorMsg = 'No Result Found !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
 }
generateResult(exam_id,student_id)
{
  //this.loading = true;
  //this.spinner.show();
  const headers = { 'Authorization': 'Bearer '+ this.globals.mockAPIkey};
  //const body = { idExam: exam_id, idStudent: this.studentid };
  //this.http.get<any>("https://admintest.pareekshn.in/ams/generateresult?idStudent="+student_id+"&idExam="+exam_id, { headers }).subscribe((res: any) => {
  this.http.get<any>("https://mypanel.pareekshn.com/ams/generateresult?idStudent="+student_id+"&idExam="+exam_id, { headers }).subscribe((res: any) => {
      var translateRes = res;
      if (res.status_code == 1000) {
        this.loading = false;
        this.spinner.hide();         
        this.pdfLink = 'https://mypanel.pareekshn.com/ams/'+res.pdf_url;
        //this.pdfLink = 'https://admintest.pareekshn.in/ams/'+res.pdf_url;
        window.open(this.pdfLink, "_blank");
      }
      else {
        this.loading = false;
        this.spinner.hide(); 
      }
        
  });
 } 
 examID: any;
reTakeExam()
{
  this.loading = true;
  this.spinner.show();
  const headers = { 'Authorization': 'Bearer '+ this.globals.mockAPIkey};
  //const body = { idExam: exam_id, idStudent: this.studentid };
  //this.http.get<any>("https://admintest.pareekshn.in/ams/reset-mtexam?idStudent="+this.sel_studentid+"&idExam="+this.sel_examid, { headers }).subscribe((res: any) => {
  this.http.get<any>("https://mypanel.pareekshn.com/ams/reset-mtexam?idStudent="+this.sel_studentid+"&idExam="+this.sel_examid, { headers }).subscribe((res: any) => {
      var translateRes = res;
      if (res.status_code == 1000) {
        this.loading = false;
        this.spinner.hide(); 
        this.examID = this.sel_examid;    
        sessionStorage.setItem('pkshn_select_exam_ps', this.examID);    
        this.router.navigateByUrl('/login/'+ btoa(res.passcode)); 
      }
      else {
        this.loading = false;
        this.spinner.hide(); 
      }
        
  });
 } 
  sel_examid: number = 0;
  sel_studentid: number = 0;
  reTakeConfirm(exam_id, student_id)
  {
    this.sel_examid = exam_id;
    this.sel_studentid = student_id;
  } 
  sectorlists()
  {
    this.router.navigateByUrl('/sectors');
  }
  resultstats;
  resultStatistics() {   
    this.authenticationService.resultStats(this.globals.root_url, this.studentid, this.usertoken)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data)
          //this.spinner.hide();
          if (data.code == 1000) {
            this.resultstats = data.statistics;
            this.pieChartData = [this.resultstats.pass, this.resultstats.fail, this.resultstats.no_result];
          }
          else {
            //this.isErrorUsername = true;
            //this.errorMsg = data.status;
            this.loading = false;
          }
          //this.spinner.hide();
        },
        error => {
          this.isErrorUsername = true;
          this.errorMsg = 'No Data Found !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
  }
  examfee: boolean = false;
  examfeedetail(i)
  {
      this.examfee = true;
      document.getElementById('fee-area_'+i).style.display = 'block';
  } 
  buyExam(examid)
  {
    this.router.navigateByUrl('/buyexam/'+examid+'@'+this.studentid);  
    //console.log('/buyexam/'+examid+'@'+this.studentid);
  }  
}





